import { DeeplyReadonly, Query } from '@cubejs-client/core';
import { useCubeQuery } from '@cubejs-client/react';
import { GridPaginationModel } from '@mui/x-data-grid-pro';
import { useMemo, useState } from 'react';

import { getPrimaryValue } from '~/util/cube/getPrimaryValue';

interface Options {
  countMeasure: string;
}

export const usePaginatedCube = (query: DeeplyReadonly<Query>, { countMeasure }: Options) => {
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({ pageSize: 5, page: 0 });
  const onPaginationModelChange = useMemo(
    () => (newModel: GridPaginationModel) => {
      setPaginationModel(newModel);
    },
    [],
  );
  const { resultSet: totalCountResultSet, isLoading: countLoading } = useCubeQuery({
    ...query,
    dimensions: [],
    measures: [countMeasure],
  });

  const rowCount = getPrimaryValue(totalCountResultSet, countMeasure) ?? 0;

  const { resultSet, isLoading: rowsLoading } = useCubeQuery({
    ...query,
    limit: paginationModel.pageSize,
    offset: paginationModel.page * paginationModel.pageSize,
  });

  const rows = resultSet?.rawData() ?? [];
  const loading = rowsLoading || countLoading;
  return {
    rows,
    rowCount,
    loading,
    paginationModel,
    onPaginationModelChange,
  };
};
